/**
 * Whether what a person typed into a type-to-confirm field says the phrase,
 * read the way people type in any language: the Unicode form (NFC or NFD)
 * and accent marks do not count (Vietnamese "xóa" and "xoá" place the tone
 * mark differently and look alike), nor do letter case, surrounding spaces
 * or runs of whitespace.
 */
export function matchesConfirmPhrase(typed: string, phrase: string): boolean {
  return foldConfirmPhrase(typed) === foldConfirmPhrase(phrase)
}

function foldConfirmPhrase(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
}
